import { Injectable } from '@angular/core';
import { OrgInitService } from './org-init.service';
import { ThemeService } from './theme.service';
import { firstValueFrom } from 'rxjs';
import { Global } from '../Shared/global';
import { AppConfigService } from './appconfig.service';

@Injectable({
  providedIn: 'root'
})
export class AppInitializer {

  constructor(
    private orgInitService: OrgInitService,
    private themeService: ThemeService,
    private appConfigService: AppConfigService
  ) { }

  /**
   * Main initialization function - called before app bootstrap
   */
  initialize(): Promise<void> {
    Global.Log('[AppInitializer] Starting initialization...');

    // Step 1: Initialize org validation
    return firstValueFrom(
      this.orgInitService.initializeOrgValidation()
    )
      .then(result => {
        Global.Log('[AppInitializer] Org validation result:', result);

        if (result.success) {
          Global.Log('[AppInitializer] Org valid - loading theme');
          // Step 2: Load theme configuration after org is set
          //return this.themeService.loadThemeConfig();
          return this.appConfigService.loadAppConfig();
        } else {
          Global.Log('[AppInitializer] Org invalid - loading default theme');
          // Still load theme even if org is invalid for login page
          //return this.themeService.loadThemeConfig();
          return this.appConfigService.loadAppConfig();
        }
      })
      .then(themeConfig => {
        Global.Log('[AppInitializer] Theme loaded:', themeConfig);
      })
      .catch(error => {
        Global.LogError('[AppInitializer] Error:', error);
        // Continue even if theme loading fails
      })
      .then(() => {
        Global.Log('[AppInitializer] Initialization complete');
      });
  }
}
